<template>
  <div class="order-recommend-product-prompt-message">
    <ym-card class="prompt-message-card"
             :title="title"
    >
      <div class="message">{{ content }}</div>
      <template v-if="showRecommend">
        <div class="recommend-hint">
          <span class="text">{{ hint }}</span>
          <slot></slot>
        </div>
      </template>
    </ym-card>
    <slot name="bottom"></slot>
  </div>
</template>
>
<script>
  import Card from '@/components/Card';

  export default {
    name: 'OrderRecommendLayout',
    components: {
      'ym-card': Card,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      content: {
        type: String,
        required: true,
      },
      showRecommend: {
        type: Boolean,
        default: false,
      },
      hint: {
        type: String,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .prompt-message-card {
    margin: @size-base;
    padding-bottom: @size-base;
  }

  .message {
    font-size: @font-size-medium;
    text-align: left;
    color: @color-text-light;
    margin-top: @size-extra-medium;
  }

  @recommend-hint-height: @size-medium;
  .recommend-hint {
    position: relative;
    text-align: center;
    line-height: 1;
    margin: @size-extra-medium auto 0;
    &::after {
      position: absolute;
      top: (@recommend-hint-height / 2);
      left: 0;
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background-color: @color-gray-light;
    }
    .text {
      display: inline-block;
      position: relative;
      z-index: @z-index-large;
      background-color: @color-primary-aide;
      color: @color-white;
      font-size: @font-size-small;
      line-height: @recommend-hint-height;
      padding: 0 @size-base;
      border-radius: @border-radius-medium;
    }
  }

</style>
